import React from "react";
import PropTypes from "prop-types";

const PlanDetails = ({ contract, resources }) => (
  <div className="content-wrapper plan-details-wrapper">
    <div className="plan-details-container">
      <div className="pd-top">
        <div className="pd-top-left">
          <h1 className="pd-title">Plan Details</h1>
          <div className="service-name">
            <h3 className="pd-subtitle">Service Name</h3>
            <h3>
              <b>{contract.name}</b>
            </h3>
          </div>
          <div>
            <h3 className="pd-subtitle">Managed Services Coordinator</h3>
            <h3>Andy Cote</h3>
          </div>
        </div>
        <div className="pd-top-right">
          <div className="tier-box">
            <h4>Plan Tier</h4>
            <h1>{contract.tier?.label}</h1>
          </div>
          <div>
            {resources.length > 1 ? (
              <React.Fragment>
                <h3 className="pd-subtitle">Primary Resources</h3>
                <ul>
                  {resources.map((res) => (
                    <li key={res}>
                      <h3>{res}</h3>
                    </li>
                  ))}
                </ul>
              </React.Fragment>
            ) : null}
            {resources.length <= 1 ? (
              <React.Fragment>
                <h3 className="pd-subtitle">Primary Resource</h3>
                <h3>{resources[0]}</h3>
              </React.Fragment>
            ) : null}
          </div>
        </div>
      </div>
      <div className="pd-bottom">
        <div>
          <h3 className="pd-subtitle">Service Coverage</h3>
        </div>
        <div>
          <span className="sla-type">Low SLA -</span>
          <span>
            Within {contract.tier?.low_sla} hours of receiving notice - Issue
            involves most users or is mission-critical in nature. No workarounds
            are available
          </span>
        </div>
        <div>
          <span className="sla-type">Normal SLA -</span>
          <span>
            Within {contract.tier?.normal_sla} hours of receiving notice - Issue
            affects a small group of users and has a moderate impact on
            productivity. Workarounds are available
          </span>
        </div>
        <div>
          <span className="sla-type">High SLA -</span>
          <span>
            Within {contract.tier?.high_sla} hours of receiving notice - Issue
            affects a single user and has no significant impact on productivity
          </span>
        </div>
      </div>
    </div>
  </div>
);

PlanDetails.propTypes = {
  contract: PropTypes.object,
  resources: PropTypes.array
};

PlanDetails.defaultProps = {
  contract: {},
  resources: []
};

export default PlanDetails;
